import { Categories } from "./Categories";

export const CategoriesPage: React.FC = () => <Categories />;
